import { Breakpoint, useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function Responsive({ query = '(min-width:600px)', children, breakpoint = null }: { query?: string; children: React.ReactNode; breakpoint?: Breakpoint | null }) {
    const theme = useTheme();
    const matches = useMediaQuery(breakpoint ? theme.breakpoints.up(breakpoint) : query);

    if (matches) return children;
    return null;
}